module.exports = __webpack_public_path__ + "img/Frame-1.282f15dd.png";